
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/managed-services",
      function () {
        return require("private-next-pages/services/managed-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/managed-services"])
      });
    }
  